import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_MAI002_Request,
  IAPI_MAI002_Response,
} from "../../../type/apiType";

// メール一覧参照
// API仕様書_メール
const httpAPI_MAI002 = async (
  param: IAPI_MAI002_Request
): Promise<IAPI_MAI002_Response> => {
  let res = await http.post(ApiUrl.API_MAI002, {
    ...param,
  });

  return res.data;
};

export { httpAPI_MAI002 };
